import { Radio } from '@typings';
import React from 'react';

import { RadioPill } from './RadioPill';

export const RadioPills = <T extends string>({
  describedById,
  isRequired,
  labelledById,
  name,
  options,
  value,
  color,
  onBlur,
  onChange,
}: Radio.Pills<T>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as T);
  };

  return (
    <div role="radiogroup" aria-labelledby={labelledById} aria-describedby={describedById} className="flex flex-col gap-2">
      {options.map((option, index) => (
        <RadioPill
          key={`${option.value}-${index}`}
          name={name}
          value={option.value}
          required={isRequired}
          checked={option.value === value}
          onBlur={onBlur}
          onChange={handleChange}
          description={option.description}
          postfix={option.postfix}
          color={color}
        >
          {option.name}
        </RadioPill>
      ))}
    </div>
  );
};
